const ResumenTutorCard = ({ nombre, total, cantidad }) => {
  return (
    <div className="flex items-center justify-between p-3 bg-white rounded-lg shadow-sm border border-gray-200">
      <div>
        <p className="font-bold text-gray-800">{nombre}</p>
        <p className="text-xs text-gray-500">{cantidad} pago(s) este mes</p>
      </div>
      <p className="text-lg font-semibold text-green-600">
        ${total.toLocaleString('es-CO')}
      </p>
    </div>
  );
};

export default ResumenTutorCard;